<!--
    描述：主体菜单范围管理
    日期：2021/06/07
    作者：zwh

    edit by 王帅
    日期：2021-06-17
    修改内容： 完善页面
-->
<template>
    <div class="h100">
        <wSplit class="h100" v-model="splitValueL">
            <div class="w-page-main left" slot="left">
                <div class="w-page-header">
                    <div class="left-text overflow-hidden">
                        <span><b>主体列表</b></span>
                    </div>
                    <div class="btnGroups ml10">
                        <el-button
                            type="primary"
                            size="small"
                            @click="addClick()"
                            v-if="roleBtns.includes('limit_menu_range_limit_add')"
                            >新增主体</el-button
                        >
                    </div>
                </div>
                <div class="w-page-container pdb10">
                    <LimitTable ref="limitTable" @row-click="limitRowClick"></LimitTable>
                </div>
            </div>
            <div class="h100" slot="right">
                <wSplit v-model="splitValueR">
                    <template slot="left">
                        <wSplit v-model="menuSplit" min="10px" max="10px">
                            <div class="h100" slot="left">
                                <MenuTree ref="menuTree" :limitId="currentRowId"></MenuTree>
                            </div>
                            <div class="h100" slot="right">
                                <MenuTreeInner ref="innerMenu" :limitId="currentRowId"></MenuTreeInner>
                            </div>
                        </wSplit>
                    </template>
                    <div class="h100" slot="right">
                        <UnitTable ref="unitTable" :currentRowName="currentRowName"></UnitTable>
                    </div>
                </wSplit>
            </div>
        </wSplit>
    </div>
</template>
<script>
import { mapState } from "vuex";
import LimitTable from "./components/limit_table";
import MenuTree from "./components/menu_tree";
import MenuTreeInner from "./components/menu_tree_inner";
import UnitTable from "./components/unit_table";
import * as MenuApi from "api/system/menu.js";
import {
    getMenuRangeByLimitId,
} from "api/system/sysLimitMenuRange.js";
export default {
    name: "",
    components: {
        LimitTable,
        MenuTree,
        MenuTreeInner,
        UnitTable
    },
    data() {
        return {
            splitValueL: 0.25,
            splitValueR: 0.5,
            menuSplit: 0.5,
            currentRowId: '',
            currentRowName: ''
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.getAllMenu();
        });
    },
    methods: {
        // 获取全部 列表
        getAllMenu() {
            MenuApi.selectLimitTree({ isSys: 0 })
                .then((res) => {
                    // 管理内菜单
                    this.$refs.menuTree.treeObj.treeOriData = res.data.systemMenu;
                    this.$refs.menuTree.treeObj.data = res.data.systemMenu.concat();

                    // 项目内菜单
                    this.$refs.innerMenu.treeObj.treeOriData = res.data.projectMenu;
                    this.$refs.innerMenu.treeObj.data = res.data.projectMenu.concat();
                })
                .catch((err) => {});
        },

        // 左侧主体行点击事件
        limitRowClick(row) {
            this.currentRowId = row.id
            this.currentRowName = row.sname
            let param = {
                limitId: row.id,
            };

            this.$refs.menuTree.treeDefaultCheckedKey = []
            this.$refs.innerMenu.treeDefaultCheckedKey = []

            // 获取主体对应的菜单范围信息
            getMenuRangeByLimitId(param)
                .then((res) => {
                    if (res.operationCode == 1) {
                        // 更新
                        this.$refs.menuTree.updateTree(res.data.systemMenu)
                        this.$refs.innerMenu.updateTree(res.data.projectMenu)

                        // 审计单位列表
                        this.$refs.unitTable.tableObj.data = res.data.tenant;
                        this.$refs.unitTable.defaultData = JSON.parse(JSON.stringify(res.data.tenant));
                    }
                })
                .catch(err => {})
            // this.$refs.menuTree.limitTo(param);
            // this.$refs.innerMenu.limitTo(param);
        },

        // 新增主体
        addClick() {
            this.$refs.limitTable.doClick("add", "");
        },
    },
    computed: {
        ...mapState("menu", {
            roleBtns: (state) => state.roleBtns,
        }),
    },
};
</script>
<style lang="less"></style>
